import {Injectable} from "@angular/core";
import {FactoryInterface} from "../factory.interface";
import * as _ from 'lodash';

@Injectable()
export class DropdownItemFactory implements FactoryInterface {
    build(settings, product = false) {
        const source = _.get(settings, 'source', []);
        if(settings.type && settings.type == 'billing'){
            return source.map(item => {
                return {
                    id: _.get(item, _.get(item, 'id', '_id')),
                    itemName: _.get(item, _.get(item, 'itemName', 'name')),
                    active: _.get(item, 'active', 'active')
                };
            });
        }else if (settings.type && settings.type == 'excellence'){
            return source.map(item => ({
                    id: _.get(item, _.get(item, 'id', '_id')),
                    itemName: _.get(item, _.get(item, 'itemName', 'name')),
                    active: _.get(item, 'active', 'active'),
                    code: _.get(item, 'code', 'code'),
                    sapCode: _.get(item, 'sapCode', 'sapCode'),
                    value: 0,
                    percentage: 0,
            }));
        }
        else{
            return source.map(item => {
                    return {
                        id: _.get(item, _.get(item, 'id', '_id')),
                        itemName: _.get(item, _.get(item, 'itemName', 'name')),
                        sapItemCode: _.get(item, _.get(item, 'sapItem', 'sapItemCode')),
                        sapProjectId: _.get(item, _.get(item, 'sapProject', 'sapProjectId')),
                        value: _.get(item,  'valuePaidCustomer', 'valuePaidCustomer'),
                        industry: _.get(item, 'industry', 'industry')
                    };
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/factories/dropdown/dropdown-item.factory.ts